import styled from 'styled-components';
import { COLORS } from '../../../../../../../constants/radar';

export const RadioGroup = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 24px;
  margin-top: 8px;
  position: relative;
`;

export const RadioOption = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
  position: relative;
  transition: all 0.2s ease;
`;

export const RadioInput = styled.input`
  position: absolute;
  opacity: 0;
  cursor: pointer;
  height: 0;
  width: 0;

  &:checked + label {
    font-weight: 600;
    background-color: ${COLORS.BACKGROUND};
    transform: scale(1.05);
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  }

  &:focus + label {
    box-shadow: 0 0 0 2px ${COLORS.BACKGROUND};
  }
`;

export const RadioLabel = styled.label`
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 12px;
  border-radius: 4px;
  cursor: pointer;
  transition: all 0.2s ease;
  width: 100%;
  color: ${COLORS.PRIMARY};
  border: 2px solid transparent;

  &:hover {
    background-color: ${COLORS.BACKGROUND};
    transform: scale(1.02);
  }

  ${props => props.checked && `
    border-color: ${COLORS.PRIMARY};
    background-color: ${COLORS.BACKGROUND};
    transform: scale(1.05);
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  `}
`;

export const RadioDot = styled.span`
  width: 12px;
  height: 12px;
  border-radius: 50%;
  background-color: ${props => props.color};
  display: inline-block;
  margin-right: 4px;
  transition: all 0.2s ease;

  ${RadioInput}:checked + ${RadioLabel} & {
    transform: scale(1.2);
    box-shadow: 0 0 0 2px ${COLORS.BACKGROUND};
  }
`;

export const StageArrow = styled.div`
  position: absolute;
  top: 50%;
  right: -16px;
  transform: translateY(-50%);
  display: flex;
  align-items: center;
  color: #666;

  &::after {
    content: '⇄';
    font-size: 16px;
  }
`;

export const Label = styled.label`
  font-weight: 500;
  color: ${COLORS.PRIMARY};
  font-size: 14px;
`;

export const Field = styled.div`
  width: 100%;
  padding-bottom: 24px;
`;
